import { Component, Input } from '@angular/core';

/**
 * Used to work around i18n limitations
 */
@Component({
    selector: '[render-history-status]',
    template: `
        @switch (status) {
            @case ('1') {
                <ng-container
                    i18n="orderStatus - in progress@@orderStatus.in.progress">
                    In progress
                </ng-container>
            }
            @case ('2') {
                <ng-container
                    i18n="orderStatus - confirmed@@orderStatus.confirmed">
                    Confirmed
                </ng-container>
            }
            @case ('3') {
                <ng-container
                    i18n="orderStatus - ready to ship@@orderStatus.readyToShip">
                    Ready to ship
                </ng-container>
            }
            @case ('4') {
                <ng-container i18n="orderStatus - shipped@@orderStatus.shipped">
                    Shipped
                </ng-container>
            }
            @default {
                <ng-container i18n="orderStatus - unknown@@orderStatus.unknown">
                    Unknown
                </ng-container>
            }
        }
    `,
    standalone: true,
})
export class RenderHistoryStatusComponent {
    @Input() status: string;
}
